import { render, staticRenderFns } from "./DReceive.vue?vue&type=template&id=c402d340&"
import script from "./DReceive.vue?vue&type=script&lang=js&"
export * from "./DReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports